import React, { useState, useCallback, useEffect } from 'react';
import Home from './pages/Home';
import ThemeSwitcher from './components/ThemeSwitcher';
import Particles from 'react-particles';
import { loadSlim } from 'tsparticles-slim';
import { Container, Engine } from 'tsparticles-engine';

const App: React.FC = () => {
  const [darkMode, setDarkMode] = useState<boolean>(false);
  const toggleTheme = () => {
    setDarkMode(prev => !prev);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setDarkMode(true);
    }
  }, []);

  useEffect(() => {
    // Save the theme to localStorage
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const particlesInit = useCallback(async (engine: Engine) => {
    console.log(engine);
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container: Container | undefined) => {
    await console.log(container);
  }, []);

  return (
    <div className={`min-h-screen relative ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-black'}`}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: 'transparent',
            },
          },
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: 'push',
              },
              onHover: {
                enable: true,
                mode: 'repulse',
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 2,
              },
              repulse: {
                distance: 150,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: darkMode ? '#ffffff' : '#000000', 
            },
            links: {
              color: darkMode ? '#ffffff' : '#000000', 
              distance: 100,
              enable: true,
              opacity: 0.3,
              width: 1,
            },
            move: {
              direction: 'none',
              enable: true,
              outModes: {
                default: 'bounce',
              },
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 65,
            },
            opacity: {
              value: 0.3,
            },
            shape: {
              type: 'circle',
            },
            size: {
              value: { min: 1, max: 4 },
            },
          },
          detectRetina: true,
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
        }}
      />
      <ThemeSwitcher darkMode={darkMode} toggleTheme={toggleTheme} />
      <Home />
    </div>
  );
};

export default App;
